<template>
    <div class="box">
        <div class="header">
            <i class="el-icon-arrow-left" @click="$router.go(-1)"></i><span @click="$router.go(-1)">身份证管理</span>
        </div>


        <div class="container">
            <div class="content">

                <el-card class="box-card" shadow="never">
                    <div class="header-title">
                        <span class="title-text">身份证快过期名单列表</span>
                        <span class="title-tip">（证件有效期 ≤ 当前日期 + 30天）</span>
                    </div>

                    <div class="operation-bar">
                        <div class="el-button space" @click="icSyncAllExpired">
                            同步证件有效期过期员工
                        </div>
                        <div class="update-time">
                            更新时间：{{ updateTime }}
                        </div>
                    </div>

                    <div class="search-form">
                        <el-input v-model="noSubPageQuery.key" placeholder="请输入人员姓名或者工号" style="width: 200px;"
                            class="filter-item" clearable />
                        <div class="search-btn sb-btn" @click="handleNoSubSearch">
                            查询
                        </div>
                    </div>

                    <div class="table">

                        <el-table :data="waitOperationTableList" border stripe height="54vh"
                            style="width: 100%; margin-top: 20px">
                            <!-- <el-table-column prop="index" label="序号" width="60" align="center"></el-table-column> -->
                            <el-table-column prop="empNo" label="工号" width="100"></el-table-column>
                            <el-table-column prop="title" label="姓名" width="100"></el-table-column>
                            <el-table-column prop="idaddress" label="证件签发机关" min-width="150"></el-table-column>
                            <el-table-column prop="IDENDDATE" label="证件有效期" width="120"></el-table-column>
                            <el-table-column prop="nativePlace" label="籍贯" width="100"></el-table-column>
                            <el-table-column prop="householdRegister" label="户籍" width="70">
                                <template slot-scope="scope">
                                    <span>
                                        {{ fmtHouseReg(scope.row.householdRegister) }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="permanentAddress" label="户籍地址" min-width="180"></el-table-column>
                            <el-table-column prop="liveAddress" label="家庭地址" min-width="180"></el-table-column>
                            <el-table-column prop="status" label="上传状态" width="100">
                                <template slot-scope="scope">
                                    <span>
                                        {{ fmtStatusTxt(scope.row.status) }}
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>

                    </div>
                    <div class="pagination">
                        <el-pagination :page-size="noSubPageQuery.pageSize" :current-page="noSubPageQuery.page" :pager-count="11"
                            layout="total,prev, pager, next" :total="noSubTotal" @current-change="noSubPageChange">
                        </el-pagination>
                    </div>
                </el-card>
            </div>
        </div>

        <div class="container">
            <div class="content">



                <el-card class="box-card" shadow="never">
                    <div class="header-title">
                        <span class="title-text">已上传身份证列表</span>
                    </div>

                    <div class="filter-container">
                        <el-button type="primary" class="sync-btn" @click="handleAllSync">
                            一键同步到HR系统
                        </el-button>

                        <div class="search-form">
                            <el-input v-model="listQuery.title" placeholder="请输入人员姓名" style="width: 200px;"
                                class="filter-item" clearable />
                            <el-date-picker v-model="dateRange" type="daterange" range-separator="—" format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd" start-placeholder="上传开始日期" end-placeholder="结束日期"
                                style="width: 300px; margin-left: 10px;" class="filter-item" />
                            <el-button type="primary" icon="el-icon-search" class="search-btn sb-btn" @click="handleSearch">
                                查询
                            </el-button>
                        </div>
                    </div>

                    <el-table :data="subTableList" @selection-change="handleSelectionChange" border height="54vh"
                        style="width: 100%; margin-top: 20px">
                        <!-- <el-table-column prop="index" label="序号" width="55" align="center" /> -->
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="empNo" label="工号" width="90" />
                        <el-table-column prop="title" label="姓名" width="80" />
                        <el-table-column prop="idaddress" label="证件签发机关" min-width="120" />
                        <el-table-column prop="IDENDDATE" label="证件有效期" width="110" />
                        <el-table-column prop="nativePlace" label="籍贯" width="90" />
                        <el-table-column prop="householdRegister" label="户籍" width="70">
                            <template slot-scope="scope">
                                <span>
                                    {{ fmtHouseReg(scope.row.householdRegister) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="permanentAddress" label="户籍地址" min-width="140" show-overflow-tooltip />
                        <el-table-column prop="liveAddress" label="家庭住址" min-width="140" show-overflow-tooltip />
                        <el-table-column prop="submitTime" label="上传日期" width="110" />

                        <el-table-column label="身份证正面" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tooltip content="查看后可下载图片" placement="top" effect="light">
                                    <el-link type="primary" :underline="false"
                                        @click="viewImage(scope.row.frontUrl)">查看图片</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column label="身份证反面" width="100" align="center">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false"
                                    @click="viewImage(scope.row.backUrl)">查看图片</el-link>
                            </template>
                        </el-table-column>

                        <el-table-column prop="statusTxt" label="状态" width="120">
                            <template slot-scope="scope">
                                <span>
                                    {{ fmtStatusTxt(scope.row.status) }}
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" width="100" fixed="right" align="center">
                            <template slot-scope="scope">
                                <!--  v-if="scope.row.status === 100010100020"  -->
                                <div class="operation-links">
                                    <el-link :disabled="scope.row.status === 100010100030" type="primary" :underline="false"
                                        @click="handleEdit(scope.row)">编辑</el-link>
                                    <el-link :disabled="scope.row.status === 100010100030" type="primary" :underline="false" style="margin-left: 10px;"
                                        @click="handleSync(scope.row)">同步</el-link>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="pagination">
                        <el-pagination :page-size="listQuery.pageSize" :current-page="listQuery.page" :pager-count="11"
                            layout="total,prev, pager, next" :total="subTotal" @current-change="subPageChange">
                        </el-pagination>
                    </div>
                </el-card>

            </div>
        </div>


        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="resetForm">
            <el-form ref="editForm" :model="formData" :rules="rules" label-width="110px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="title">
                            <el-input v-model="formData.title" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工号" prop="empNo">
                            <el-input v-model="formData.empNo" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="籍贯" prop="nativePlace">
                    <el-input v-model="formData.nativePlace" placeholder="请输入籍贯"></el-input>
                </el-form-item>

                <el-form-item label="户口性质" prop="householdRegister">
                    <el-select v-model="formData.householdRegister" placeholder="请选择" style="width:100%">
                        <el-option label="农村" value="1246"></el-option>
                        <el-option label="城镇" value="1247"></el-option>
                    </el-select>
                </el-form-item>

                
                <el-form-item label="戶籍地址" prop="permanentAddress">
                    <el-input type="textarea" v-model="formData.permanentAddress"></el-input>
                </el-form-item>

                <el-form-item label="家庭地址" prop="liveAddress">
                    <el-input type="textarea" v-model="formData.liveAddress"></el-input>
                </el-form-item>

                <el-form-item label="证件签发机关" prop="idaddress">
                    <el-input v-model="formData.idaddress" placeholder="请输入签发机关"></el-input>
                </el-form-item>

                <el-form-item label="有效期" required>
                    <el-col :span="11">
                        <el-form-item prop="idStartDate">
                            <el-date-picker v-model="formData.idStartDate" type="date" placeholder="开始日期"
                                style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                    <el-col :span="11">
                        <el-form-item prop="idenddate">
                            <el-date-picker v-model="formData.idenddate" type="date" placeholder="截止日期"
                                style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitEdit">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog title="查看证件" :visible.sync="icVisible" width="30%">
            <img style="width: 100%; height: 300px;" :src="imgUrl" />
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";

import apiMedal from "@/apis/medal";

import { showLoading, hideLoading } from '@/utils/loading';

export default {
    name: "importWages",
    components: {},
    data() {
        const imgUrlPrefix = apiMedal.hrApiPrefix;

        return {
            dialogVisible: false,
            dialogTitle: '编辑人员信息',
            // 初始化数据结构
            formData: {
                id: "",
                empID: "",
                title: "",
                empNo: "",
                permanentAddress: "",
                householdRegister: "",
                idaddress: "",
                nativePlace: "",
                liveAddress: "",
                idenddate: "",
                idStartDate: null
            },
            // 使用我们之前讨论过的 rules
            rules: {
                nativePlace: [{ required: true, message: '籍贯不能为空', trigger: 'blur' }],
                idaddress: [{ required: true, message: '签发机关不能为空', trigger: 'blur' }],
                // ... 加上你之前的日期逻辑
            },
            icVisible: false,
            imgUrl: '',
            imgUrlPrefix,
            idList: [],
            dateRange: [],
            listQuery: {
                title: '',
                page: 1,
                pageSize: 20,
                subStartDate: null,
                subEndDate: null,
                operationUserEmpNo: null,
            },
            updateTime: '',
            waitOperationTableList: [],
            noSubPageQuery: {
                key: "",
                page: 1,
                pageSize: 20,
            },
            noSubTable: [],
            noSubTotal: 0,
            subTableList: [],
            subTotal: 0,
            subPage: {
                page: 1,
                pageSize: 20,
            },
        };
    },
    mounted() {
        this.loadSynInfo();
        this.loadNotSub();
        this.loadSub();
    },
    methods: {
        handleEdit(row) {
            console.log('hhhhh, ', row)
            this.dialogTitle = `编辑 - ${row.title}`;
            // 重要：使用深拷贝，防止修改 Modal 时直接改变了表格行的数据
            this.formData = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;

            // 如果有图片组件需要手动校验
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.clearValidate();
            });
        },

        // 提交修改
        submitEdit() {
            this.$refs.editForm.validate(async (valid) => {
                if (!valid) return;

                try {
                    showLoading('正在保存...');
                    // 发送请求给后端
                    const res = await api.icEditCardInfo(this.formData);

                    if (res.code === 200) {
                        this.$message.success('修改成功');
                        this.dialogVisible = false;
                        this.handleSearch(); // 刷新列表
                    } else {
                        this.$message.error(res.message || '保存失败');
                    }
                } catch (e) {
                    console.log('upd err, ', e)
                } finally {
                    hideLoading();
                }
            });
        },

        // 关闭 Modal 时清空校验状态
        resetForm() {
            this.$refs.editForm.resetFields();
        },
        async handleAllSync() {
            const selectCount = this.idList.length;
            if (selectCount === 0) {
                this.$message.warning('请先勾选需要同步的人员');
                return;
            }

            // 2. 弹出确认框
            try {
                await this.$confirm(
                    `确定将选中的 <span style="color:red;font-weight:bold;">${selectCount}</span> 位人员信息同步到 HR 系统吗？`,
                    '批量同步确认',
                    {
                        confirmButtonText: '立即同步',
                        cancelButtonText: '取消',
                        type: 'warning',
                        dangerouslyUseHTMLString: true // 允许提示词中使用红字加粗
                    }
                );

                // 3. 准备数据：提取 ID 数组
                const ids = this.idList;

                // 4. 显示 Loading（使用你之前封装好的）
                showLoading(`正在同步 ${selectCount} 条记录...`);

                // 5. 调用后端批量接口
                const res = await api.icBatchSyncHr({ idList: ids });

                if (res.code === 200) {
                    this.$message({
                        type: 'success',
                        message: `成功同步 ${selectCount} 条数据！`,
                        duration: 3000
                    });
                    this.handleSearch(); // 刷新列表
                } else {
                    this.$message.error(res.message || '同步失败');
                }

            } catch (error) {
                // 用户取消操作
                if (error === 'cancel') {
                    this.$message.info('已取消一键同步');
                } else {
                    console.error('批量同步异常:', error);
                }
            } finally {
                // 关闭 Loading
                hideLoading();
            }
        },
        handleSearch() {
            console.log('date ', this.dateRange)
            this.idList = [];
            const dr = this.dateRange;
            if (dr && dr.length === 2) {
                this.listQuery.subStartDate = dr[0];
                this.listQuery.subEndDate = dr[1];
            }

            this.loadSub();
        },
        handleSelectionChange(val) {
            console.log('val, ', val);
            this.idList = val.map(x => x.id);
        },
        reset() {
            this.dateRange = [];
            this.listQuery.subStartDate = null;
            this.listQuery.subEndDate = null,
                this.listQuery.title = null;
        },
        viewImage(suffix) {
            const url = this.imgUrlPrefix + suffix;
            console.log('img, ', url)
            this.imgUrl = url;
            this.icVisible = true;
        },
        async handleSync(row) {
            console.log('sync, ', row)
            // api.icBatchSyncHr({idList: [row.]})
            try {
                // 1. 弹出确认框
                await this.$confirm(`确认将人员【${row.title}】的信息同步到 HR 系统吗？`, '操作确认', {
                    confirmButtonText: '确定同步',
                    cancelButtonText: '取消',
                    type: 'warning',
                    // 增加圆角和居中（可选）
                    center: true
                });

                // 2. 用户点击确定后，显示你封装的 Loading
                showLoading('正在同步至 HR 系统...');

                // 3. 调用后端接口 (假设你的后端接口是 syncToHr)
                const res = await api.icBatchSyncHr({ idList: [row.id] })

                if (res.code === 200) {
                    this.$message.success('同步成功');
                    // 刷新列表
                    this.handleSearch();
                } else {
                    this.$message.error(res.data.msg || '同步失败');
                }
            } catch (error) {
                if (error === 'cancel') {
                    this.$message.info('已取消同步');
                } else {
                    console.error('同步异常:', error);
                }
            } finally {
                // 5. 无论成功失败都关闭 Loading
                hideLoading();
            }
        },
        async icSyncAllExpired() {
            const resp = await api.icSyncAllExpired();
            console.log('icSyncAllExpired, ', resp)
            if (resp && resp.code === 200) {
                this.$message.success(resp.message);
            }
        },
        async handleNoSubSearch() {
            // this.noSubPageQuery.page = 1;
            this.loadNotSub();
        },
        async noSubPageChange(p) {
            console.log('no sub page change, ', p);
            const self = this;
            self.noSubPageQuery.page = p;
            self.loadNotSub();
        },
        async loadNotSub() {
            const resp = await api.icPageNotSub(this.noSubPageQuery);
            const { data } = resp;
            const list = data.records;
            this.renderData(list);
            this.waitOperationTableList = list;
            this.noSubTotal = data.total;
            console.log('page info not sub, ', resp)
        },
        async subPageChange(p) {
            console.log('subPageChange, ', p);
            const self = this;
            self.listQuery.page = p;
            self.loadSub();
        },
        async loadSub() {
            const resp = await api.icPageSub(this.listQuery);
            const { data } = resp;
            const list = data.records;
            this.renderData(list);
            this.subTableList = list;

            this.subTotal = data.total;
            console.log('page info sub, ', resp)
        },
        async loadSynInfo() {
            const resp = await api.icSyncInfo();
            console.log(resp, ' info.')
            const { data } = resp;
            this.updateTime = moment(data.lastSyncTime).format("YYYY-MM-DD HH:mm");

        },
        fmtHouseReg(householdRegister) {
            const hj = householdRegister;
            let householdRegisterTxt = '--';
            if ("1246" === hj) {

                householdRegisterTxt = '农村'
            } else if ("1247" === hj) {
                householdRegisterTxt = '城镇'
            }
            return householdRegisterTxt;
        },
        fmtStatusTxt(status) {
            let statusTxt = '';
            if (100010100010 === status) {
                statusTxt = '待上传'
            } else if (100010100020 === status) {
                statusTxt = '待同步'
            } else if (100010100030 === status) {
                statusTxt = '已同步'
            } else {
                statusTxt = '--'
            }
            return statusTxt;
        },
        renderData(list) {
            for (const item of list) {
                // const hj = item.householdRegister;
                // console.log('hj, ', hj)
                // if ("1026" == hj) {
                //     this.$set(item, 'householdRegisterTxt', '农村');
                //     // item.householdRegisterTxt = '农村'
                // } else if ("1027" == hj) {
                //     // item.householdRegisterTxt = '城镇'
                //     this.$set(item, 'householdRegisterTxt', '城镇');
                // } else {
                //     item.householdRegisterTxt = '--0000'
                // }

                // const status = item.status;

                // if (100010100010 === status) {
                //     item.statusTxt = '待上传'
                // } else if (100010100020 === status) {
                //     item.statusTxt = '待同步'
                // } else if (100010100030 === status) {
                //     item.statusTxt = '已上传'
                // } else {
                //     item.statusTxt = '--'
                // }

            }
        },
    },
};
</script>
<style scoped lang="scss">
$zoom: 1020 / 375;



.box {
    width: 100%;
    background: #fafafa;
    min-height: 100vh;
    font-size: 12px * $zoom;
    position: relative;

    .header-title {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        padding-left: 15px;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            left: 0;
            width: 4px;
            height: 32px;
            background-color: #ff8d30; // 橙色修饰条
            border-radius: 2px;
        }

        .title-text {
            font-size: 32px;
            font-weight: bold;
            color: #333;
        }



    }



    .search-form {
        margin-left: 15px;
        display: flex;
        align-items: center;
        margin: 15px 0px;



        .sync-btn {
            margin: 10px 0px;
        }

        .search-btn {
            margin-left: 30px;
        }

        .sb-btn {
            background: #0091ff;
            height: 75px;
            width: 150px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 20px;
        }

    }

    .filter-container {
        display: flex;
        flex-direction: column;
    }



    .header {
        height: 9vh;
        background: #fff;
        padding-left: 2vw;
        font-size: 44px;
        display: flex;
        line-height: 9vh;

        i {
            font-size: 54px;
            margin-right: 20px;
            line-height: 9vh;
        }
    }

    .container {
        height: 91vh;
        padding: 4vh;

        .content {
            background: #fff;
            width: 100%;
            height: 100%;
            border-radius: 40px;
            overflow: auto;
            padding-bottom: 50px;

            .operation-bar {
                display: flex;
                flex-direction: column;
                margin-bottom: 15px;

                .update-time {
                    margin-top: 15px;
                    font-size: 30px;
                    color: #606266;
                    // border: 1px solid #dcdfe6;
                    display: inline-block;
                    padding: 2px 8px;
                    background-color: #fff;
                }
            }

            .el-button {
                height: 90px;
                width: 350px;
                background: #4fa27d;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 20px;
            }

            .space {
                margin: 20px 0;
            }

            .search {
                padding: 40px 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #eeeff2;

                .left {
                    display: flex;
                    align-items: center;
                    padding-left: 40px;

                    div {
                        height: 90px;
                        width: 160px;
                        background: #fafafa;
                        font-size: 32px;
                        color: #0e0e0e;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }

                    .active {
                        background: #4fa27d;
                        color: #fff;
                    }

                    div:nth-child(1) {
                        border-radius: 30px 0 0 30px;
                    }

                    div:nth-child(2) {
                        border-radius: 0 30px 30px 0;
                    }
                }

                .right {
                    display: flex;
                    align-items: center;
                    padding-right: 40px;
                }

                ::v-deep {
                    .el-input {
                        margin-right: 30px;
                    }

                    .el-input__inner {
                        height: 90px;
                        width: 360px;
                        background: #fafafa;
                        border: none;
                    }

                    .el-input--mini .el-input__icon {
                        line-height: 65px;
                    }

                    .el-date-editor {
                        width: 320px;
                        margin-right: 30px;

                        .el-input__inner {
                            height: 90px;
                            width: 320px;
                        }
                    }



                    .el-button2 {
                        margin-left: 30px;
                    }
                }
            }

            .table {
                padding: 60px 40px;

                // height: calc(100vh - 10rem);
                ::v-deep {
                    .el-table__empty-block {
                        width: 100% !important;
                    }

                    thead {
                        tr {
                            th {
                                background: #fafafa;
                                height: 80px;
                            }
                        }
                    }

                    tbody {
                        tr {
                            td {
                                height: 80px;
                            }
                        }
                    }

                    .el-table__body {
                        width: 100% !important;
                    }

                    .el-table th.gutter {
                        display: none;
                        width: 0;
                    }

                    .el-table colgroup col[name="gutter"] {
                        display: none;
                        width: 0;
                    }

                    .el-table--scrollable-y .el-table__body-wrapper {
                        &::-webkit-scrollbar {
                            width: 0 !important;
                        }
                    }
                }
            }

            .pagination {
                margin: 0 40px;
                // padding: 0 40px;
                height: 5vh;
                background: #fafbfc;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                ::v-deep {
                    .el-pagination {
                        button {
                            background: #fafbfc !important;
                        }

                        ul {
                            li {
                                background: #fafbfc !important;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
